import axios from 'axios';
import { backend_url } from './urls';
import { getItem, removeItem } from './localStorage';


export async function makeRequest(url, method, body) {
    try {
        const options = {
            method: method,
            url: backend_url + url,
            data: (method === 'POST' || method === 'PUT') ? body : undefined,
            responseType: 'json',
        };

        const response = await axios(options);

        if (response.status === 200) {
            return { success: true, data: response.data };
        } else {
            return { success: false, error: `Error: ${response.status} - ${response.data.error}` };
        }
    } catch (error) {
        // Extract more detailed error information
        let errorMessage;

        if (error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            errorMessage = `Error: ${error.response.status} - ${error.response.data.error}`;
        } else if (error.request) {
            // The request was made but no response was received
            errorMessage = 'Error: No response received from server';
        } else {
            // Something happened in setting up the request that triggered an Error
            errorMessage = `Error: ${error.message}`;
        }
        return { success: false, error: errorMessage };
    }
}


export async function makeRequest2(url, method, body, options = {}) {
    const { retries = 0, timeout = 30000 } = options;

    try {
        const userDetails = await getItem('APPUSER');
        if (!userDetails || !userDetails.authToken) {
            throw new Error('Authentication token not found');
        }

        const token = userDetails.authToken;

        // Check if the body is FormData
        const isFormData = body instanceof FormData;

        const requestOptions = {
            method: method,
            url: backend_url + url,
            data: (method === 'POST' || method === 'PUT' || method === 'GET' || method === 'PATCH') ? body : undefined,
            responseType: 'json',
            timeout: timeout,
            headers: {
                'Authorization': `Bearer ${token}`,
                // Set Content-Type only if body is not FormData
                ...(isFormData ? {} : { 'Content-Type': 'application/json' })
            }
        };

        const response = await axios(requestOptions);

        if (response.status === 200 || response.status === 201 || response.status === 202) {
            // Validate response data structure
            if (response.data && typeof response.data === 'object') {
                return { success: true, data: response.data };
            } else {
                console.warn('Invalid response data structure:', response.data);
                return { success: false, error: 'Invalid response data format' };
            }
        } else {
            return { success: false, error: `Error: ${response.status} - ${response.data?.error || 'Unknown error'}` };
        }
    } catch (error) {
        // Extract more detailed error information
        let errorMessage;
        let isRetryable = false;

        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                // Optional: clear token/localStorage
                await removeItem('APPUSER');

                // Redirect to login page
                window.location.href = '/';

                return {
                    success: false,
                    error: 'Session expired. Redirecting to login...',
                };
            }

            // Determine if error is retryable
            isRetryable = status >= 500 || status === 408 || status === 429;

            // The request was made and the server responded with a status code that falls out of the range of 2xx
            const errorData = error.response.data;
            errorMessage = `Error: ${status} - ${errorData?.error || errorData?.message || 'Server error'}`;
        } else if (error.request) {
            // The request was made but no response was received
            isRetryable = true;
            errorMessage = 'Error: No response received from server';
        } else if (error.code === 'ECONNABORTED') {
            // Request timeout
            isRetryable = true;
            errorMessage = 'Error: Request timeout';
        } else {
            // Something happened in setting up the request that triggered an Error
            errorMessage = `Error: ${error.message}`;
        }

        // Retry logic for retryable errors
        if (isRetryable && retries > 0) {
            console.log(`Retrying request to ${url} (${retries} retries left)`);
            await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second before retry
            return makeRequest2(url, method, body, { ...options, retries: retries - 1 });
        }

        return { success: false, error: errorMessage, isRetryable };
    }
}
